import { Navigate } from 'react-router-dom';
import routes from '../../../config/routes';

export const RedirectToNotFoundPage = () => {
    return <Navigate to={routes.notFound} replace />;
};
